var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIfu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1,
    stroke: "currentColor",
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    d: " M23,5.4 v14.4 a6,4,0,0,1,-6.55,-0.6 a6,8,0,0,0,-4.6,-0.4 a6,8,0,0,0,-4.6,0.4 a6,4,0,0,1,-6.55,0.6 v-14.4 a6,4,0,0,0,6.55,-0.6 a6,8,0,0,1,4.6,-0.4 a6,8,0,0,1,4.6,0.4 a6,4,0,0,0,6.55,0.6 Z M11.9,4.43 V18.73 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 1,
    stroke: "currentColor",
    d: " M16,11h4v4.8h1.2v0.8h-5.2v-0.8h1.2v-4h-1.2Z M17.4,8a1,1,0,0,1,2.6,0a1,1,0,0,1,-2.6,0Z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfu);
export default __webpack_public_path__ + "static/media/ifu.89a2c3e6.svg";
export { ForwardRef as ReactComponent };